import React from 'react';
// @ts-ignore
import calendarMatrix from 'calendar-matrix';
import Icon from './Icon';
import Button from './Button';
import { createCalendar } from '../../../../../../../client/components/BubbleUI/abstracts/Calendar';

export default createCalendar({
  className: 'bg-white',
  titleClassName: 'font-semibold',
  daysClassName: 'font-semibold',
  NavButton: ({ direction, onClick }) => (
    <Button
      onClick={onClick}
      className="calendar-active-text border-none font-semibold px-4 py-3 -my-3"
    >
      <Icon icon={['fass', direction === 'prev' ? 'arrow-left' : 'arrow-right']} />
    </Button>
  ),
  DayButton: ({ day, dayContext, onClick }) => {
    const { isSelectedDate, isCurrentDate, isDisabled } = dayContext;

    const classes = ['grid items-center justify-center'];

    if (isSelectedDate) {
      classes.push('calendar-active-bg font-semibold rounded-full text-white');
    } else if (isCurrentDate) {
      classes.push('calendar-active-text font-semibold rounded-full');
    }

    return (
      <Button
        className={`aspect-square grid items-center justify-center ${
          isDisabled ? 'text-gray-300 calendar-disabled-text' : ''
        }`}
        disabled={isDisabled}
        onClick={onClick}
      >
        <div style={{ width: 40, height: 40 }} className={classes.join(' ')}>
          {Math.abs(day)}
        </div>
      </Button>
    );
  },
  TodayButton: ({ onClick }) => (
    <Button onClick={onClick} className="font-semibold px-4 py-3 calendar-active-text">
      Today
    </Button>
  ),
  ClearButton: ({ onClick }) => (
    <Button onClick={onClick} className="font-semibold px-4 py-3">
      Clear
    </Button>
  ),
});
